var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sms_FILL1_wght600_GRAD0_opsz24",
    d: "M66.749-890.01a1.082,1.082,0,0,0,.8-.321,1.077,1.077,0,0,0,.322-.794,1.082,1.082,0,0,0-.321-.8,1.077,1.077,0,0,0-.794-.322,1.082,1.082,0,0,0-.8.321,1.077,1.077,0,0,0-.322.794,1.082,1.082,0,0,0,.321.8A1.077,1.077,0,0,0,66.749-890.01Zm4.032,0a1.082,1.082,0,0,0,.8-.321,1.077,1.077,0,0,0,.322-.794,1.082,1.082,0,0,0-.321-.8,1.077,1.077,0,0,0-.794-.322,1.082,1.082,0,0,0-.8.321,1.077,1.077,0,0,0-.322.794,1.082,1.082,0,0,0,.321.8A1.077,1.077,0,0,0,70.781-890.01Zm4.032,0a1.082,1.082,0,0,0,.8-.321,1.077,1.077,0,0,0,.322-.794,1.082,1.082,0,0,0-.321-.8,1.077,1.077,0,0,0-.794-.322,1.082,1.082,0,0,0-.8.321,1.077,1.077,0,0,0-.322.794,1.082,1.082,0,0,0,.321.8A1.077,1.077,0,0,0,74.813-890.01ZM60.782-879.218v-17.471a2.44,2.44,0,0,1,.736-1.793,2.44,2.44,0,0,1,1.793-.736H78.253a2.44,2.44,0,0,1,1.793.736,2.44,2.44,0,0,1,.736,1.793v11.126a2.44,2.44,0,0,1-.736,1.793,2.439,2.439,0,0,1-1.793.736H64.6Z",
    transform: "translate(-60.782 899.218)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.9c74e67a1eabe4b3dc6adb878a4a3285.svg";
export { ForwardRef as ReactComponent };